import { getNodeManager } from "@src/cloud-connect/dependency-injection-container/get-node-manager";

export const useUsersIconButtonHook = () => {
  const handleClick = () => {
    getNodeManager().performChangesCheckWhenNavigatingAwayFromNodeManager(
      "/user-management",
    );
  };

  return { handleClick };
};
